import { BoxProps } from '@mui/material'
import { FlexGrowCol, FlexGrowRow } from '@xylabs/sdk-react'
import { AuctionStatus } from '@xyo-network/sdk-xyoworld-js'
import { useContext } from 'react'

import { BidHistoryTable, Family } from '../../Components'
import { MinterAuctionContext } from '../../Contexts'
import { AuctionBuyerProperty, AuctionMinimumBidProperty, AuctionStatusProperty } from '../../Properties'

const PropertyArea: React.FC<BoxProps> = (props) => {
  const { auction } = useContext(MinterAuctionContext)
  const quadkey = auction?.quadkey

  if (auction) {
    const status = auction?.status()
    return (
      <FlexGrowCol {...props} alignItems="stretch">
        <AuctionStatusProperty />
        {status === AuctionStatus.Minted || status === AuctionStatus.Completed ? <AuctionBuyerProperty /> : null}
        {status === AuctionStatus.Live || status === AuctionStatus.Dutch ? <AuctionMinimumBidProperty /> : null}
        {quadkey ? <Family margin={0.5} quadkey={quadkey} size="small" /> : null}
        <FlexGrowRow paper margin={0.5} padding={0.5}>
          <BidHistoryTable pageSize={5} reverseOrder />
        </FlexGrowRow>
      </FlexGrowCol>
    )
  }
  return null
}

export default PropertyArea
